import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Form,
  Table,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  AddOutlined,
  WallpaperOutlined,
  DeleteForeverOutlined,
  ModeEditOutlined,
  HighlightAlt,
  ErrorOutline,
} from "@mui/icons-material";
import useHome from "../../hooks/useHome";
import useForm from "../../hooks/useForm";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import toast from "react-hot-toast";
import useAudit from "../../hooks/useAudit";
import getBanners from "../../services/getBanners";

const BannerPubPgi = ({ editBannerPub, open, showBloque, infoEdit }) => {
  const {
    banners,
    setBanners,
    setBannerEdit,
    bannerEdit,
    handleVisibilityBanners,
  } = useHome();
  const { createAuditRequest, refreshPendingsView, setRefreshPendingsView  } = useAudit();
  const [showCreateBanner, setShowCreateBanner] = useState(false);
  const [bannerNav, setBannerNav] = useState(false);
  const [showNew, setShowNew] = useState(true);
  const [modalFor, setModalFor] = useState(null);
  const handleCloseBanner = () => setShowCreateBanner(false);
  const handleShowBanner = () => {
    setShowCreateBanner(!showCreateBanner);
    setBannerNav(true);
  };

  useEffect(() => {
    getBanners().then((resp) => setBanners(resp.data.allBanner));
    setRefreshPendingsView(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPendingsView]);

  const handleShowBannerEdit = () => {
    setShowCreateBanner(!showCreateBanner);
    setBannerNav(false);
  };
  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name

  const { values, setValues, handleInputChange, reset } = useForm({
    title: "",
    body: "",
    link: "",
    state: false,
    image_desktop: [],
    creation_date: new Date(),
    // _id: String(Math.ceil(Math.random()*(999999999999 - 100000000000) + 100000000000 )),
    deleted: false,
  });

  const handleSubmitBanner = async (e) => {
    e.preventDefault();
    try {
    bannerEdit ? await createAuditRequest(
      {
        ...values,
        element: 5,
        creator: user,
        publish: true,
        visible: true,
        section: ""
      },
      "EDIT"
    ) : await createAuditRequest({
      ...values,
      deleted: false,
      element: 5,
      creator: user,
      publish: true,
    });
    setBannerEdit(null);
    setShowNew(true);
    reset();
  } catch (error) {
    toast.error("Error al actualizar el bloque de texto");
  }
  };

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">
          ¿Estas seguro de eliminar este banner publicitario?
        </div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id, "DELETE")}
          >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000,
      }
    );
  };

  const handleConfirmDelete = (id) => {
    const newDelete = banners?.find((noticia) => noticia._id === id && noticia);
    createAuditRequest(
      {
        ...newDelete,
        element: 5,
        deleted: true,
        image_desktop: [],
        image_tablet: [],
        section: [],
        creator: user,
      },
      "DELETE"
    );

    toast.dismiss();
  };

  useEffect(() => {
    setShowNew(showBloque)
    // setBannerEdit({...infoEdit})
    setValues({...infoEdit})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBloque, infoEdit]);

  return (
    <>
      {editBannerPub || infoEdit ? (
        <OverlayTrigger
          key="2"
          placement="top"
          overlay={<Tooltip id="2">Editar</Tooltip>}
        >
          <Button className="buttons_pgi_2" onClick={handleShowBannerEdit}>
            <ModeEditOutlined />
          </Button>
        </OverlayTrigger>
      ) : (
        <>
          <a id="edit-banner" variant="light" onClick={handleShowBanner}>
            <HighlightAlt />  <span>Banner publi</span>
          </a>
          {!open ? <div className="tooltips">Banner Publicitario</div> : ""}
        </>
      )}
      {/**INICIO OFF CANVAS */}
      <Offcanvas
        show={showCreateBanner}
        onHide={handleCloseBanner}
        className="basePgi__pgi  pgi__sidebar-container"
        placement="end"
        scroll="true"
        enforceFocus
        backdrop={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {!bannerNav
              ? "BANNER PUBLICITARIO - HOME"
              : "BANNER PUBLICITARIO - MENÚ PRINCIPAL"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form id="formAddBannerPub" className="basePgi__vista-edit-gral">
            <header>
              <p className="basePgi__comments">
                {!bannerNav
                  ? "Seleccione los Banners Publicitarios para incorporar en la sección"
                  : "Seleccione los Banners Publicitarios para incorporar en las distintas secciones"}
              </p>
              {!bannerNav ? (
                ""
              ) : (
              <OverlayTrigger
                key="2"
                placement="top"
                overlay={<Tooltip id="2">Nuevo Banner</Tooltip>}
              >
                  <Button
                    className="btn-form-pgi"
                    variant="light"
                    onClick={() => {
                      setShowNew(!showNew);
                      reset();
                    }}
                  >
                    <AddOutlined />
                  </Button>
              </OverlayTrigger>
                )}
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                {!bannerNav && (
                  <col span="1" className="basePgi__table-col-min" />
                )}
                <col span="1" className="basePgi__table-col-max" />
                {bannerNav && (
                  <col span="2" className="basePgi__table-col-min" />
                )}
              </colgroup>
              <tbody>
                {banners?.map(
                  (banner) =>
                    banner?.deleted === false && (
                      <>
                        <tr key={banner._id}>
                          {!bannerNav && (
                            <td className="pgi__table-check">
                              <Form.Check
                                inline
                                aria-label="banner #id" // indicar x variable el nº id
                                name="selectBanner"
                                type="checkbox"
                                id="align-left"
                                defaultChecked={banner.section.find(
                                  (item) => item === "home"
                                )}
                                onClick={() => {
                                  handleVisibilityBanners(banner._id, "home");
                                }}
                              />
                            </td>
                          )}
                          <td>{banner.title}</td>
                          {(bannerNav || infoEdit) && (
                            <>
                              <td
                                onClick={() => {
                                  setBannerEdit({ ...banner });
                                  setValues({ ...banner });
                                  setShowNew(false);
                                }}
                              >
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={<Tooltip id="2">Editar</Tooltip>}
                                >
                                  <Button>
                                    <ModeEditOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                              <td onClick={() => handleDelete(banner._id)}>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={<Tooltip id="2">Eliminar</Tooltip>}
                                >
                                  <Button>
                                    <DeleteForeverOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </>
                          )}
                        </tr>
                      </>
                    )
                )}
              </tbody>
            </Table>
            {/* {mensaje && (
              <button
                disabled
                // modificar el nombre de la sección de la q se proviene
                className="settings_button-pleno"
              >
                {mensaje}
              </button>
            )} */}
          </form>
          <hr className="basePgi__space-line" />
          <form
            className={`basePgi__vista-edit-gral ${
              showNew ? "d-none" : "d-block"
            }`}
            id="bloque-txt"
            onSubmit={handleSubmitBanner}
          >
            <header
              className="basePgi-header-border"
              aria-labelledby="formEditarHSlider"
            >
              <h2>{infoEdit ? 'Editar Banner Publicitario' : 'Nuevo Banner Publicitario'}</h2>
            </header>
            <fieldset className="pgi__sidebar-container-items form-group">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  id="title"
                  placeholder="..."
                  value={values.title}
                  onChange={handleInputChange}
                  required
                  maxLength={90}
                  minLength={2}
                />
                <label htmlFor="title">TÍtulo </label>
                <p className="basePgi__comments">
                  <span>OCULTO, sólo para identificación</span>
                </p>
              </div>

              <div className="form-floating">
                <textarea
                  required
                  type="text-area"
                  className="form-control"
                  name="body"
                  id="content"
                  rows="5"
                  for="bloque-txt"
                  value={values.body}
                  onChange={handleInputChange}
                  placeholder="hola"
                  minLength={10}
                  maxLength={280}
                />
                <label className="py-0 mb-1" htmlFor="content">
                  Información Publicitaria
                </label>
                <p className="basePgi__comments">
                  <span>Máximo de caracteres: 280.</span>
                </p>
              </div>
              <div className="form-floating">
                <input
                  required
                  type="text"
                  className="form-control"
                  name="link"
                  id="link"
                  value={values.link}
                  onChange={handleInputChange}
                  placeholder="..."
                  maxLength={180}
                />
                <label htmlFor="link">Enlace a...</label>
                <p className="basePgi__comments">
                  <span>Ejemplo: /donde-comprar</span>
                </p>
                <p className="basePgi__comments">
                  <span>Ejemplo: https://www.youtube.com/channel/UCs2eaZaC-7SNPcrbm1o2LDA</span>
                </p>
              </div>
              <hr />
              <Modal
                id="galleryModal"
                className="modalContenedor__galeria"
                show={showGaleria}
                onHide={handleCloseGaleria}
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <GaleriaPgiModal
                    editProduct={values}
                    setEditProduct={setValues}
                    modalFor={modalFor}
                    handleCloseGaleria={handleCloseGaleria}
                  />
                </Modal.Body>
              </Modal>
              <div className="form-floating">
                <div
                  className="pgi__container-img"
                  style={{ display: "none" }}
                ></div>
                <Button
                  className="btn-form-pgi pgi__head-modules"
                  onClick={() => handleModalClick("image_desktop")}
                >
                  Seleccionar imagen desktop
                  <WallpaperOutlined />
                </Button>
                <p className="basePgi__comments">
                  <span>
                    Imagen para Escritorio (.jpg, .png). Proporción 16:9
                  </span>
                </p>
                <Button
                  className="btn-form-pgi pgi__head-modules"
                  onClick={() => handleModalClick("image_tablet")}
                >
                  Seleccionar imagen tablet
                  <WallpaperOutlined />
                </Button>
                <p className="basePgi__comments">
                  <span>
                    Imagen para Tablet - Notebook (.webP, .jpg, .png).
                    Proporción 3:4
                  </span>
                </p>
              </div>
              <button type="submit" className="settings_button-pleno">
                GUARDAR
              </button>
            </fieldset>
            <hr className="basePgi__space-line" />
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default BannerPubPgi;
